import React, { useState } from "react";
import Sidebar from "./Sidebar";

const BACKEND_URL = "https://dev.meter-genie.com:5000";

const Reports = () => {
  const [reportType, setReportType] = useState("voltage");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [deviceId, setDeviceId] = useState("");

  const handleExport = async () => {
    try {
      const res = await fetch(`${BACKEND_URL}/api/export`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          reportType,
          startDate,
          endDate,
          deviceId,
        }),
      });

      if (!res.ok) throw new Error("Export failed");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${reportType}_report_${Date.now()}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {
      alert("Failed to export report");
    }
  };

  return (
    <div style={{ display: "flex", height: "100vh", background: "#eee" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "2rem" }}>
        <h2>Reports</h2>
        <div style={{ background: "#fff", padding: "1.5rem", borderRadius: "10px", maxWidth: "600px" }}>
          <h4>Generate Report</h4>

          <div style={{ marginBottom: "1rem" }}>
            <label>Report Type: </label>
            <select value={reportType} onChange={(e) => setReportType(e.target.value)} style={{ marginLeft: "1rem" }}>
              <option value="voltage">Voltage Data</option>
              <option value="blinks">Blinks</option>
              <option value="outages">Outages</option>
              <option value="alerts">Alerts</option>
              <option value="offline">Offline Devices</option>
              <option value="health">Device Health</option>
              <option value="ping">Ping History</option>
              <option value="blink-summary">Blink Summary by Device</option>
              <option value="neutral">Neutral Warnings</option>
              <option value="sag-swell">Sag and Swell</option>
            </select>
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label>Start Date: </label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            <label style={{ marginLeft: "1rem" }}>End Date: </label>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label>Device ID (optional): </label>
            <input
              type="text"
              value={deviceId}
              onChange={(e) => setDeviceId(e.target.value)}
              placeholder="Leave blank for all devices"
            />
          </div>

          <button onClick={handleExport}>Export to Excel</button>
        </div>
      </div>
    </div>
  );
};

export default Reports;
